import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import 首页 from '@/views/main.vue'
import 产品详情 from '@/views/productDetails.vue'
import 案例展示 from '@/views/case.vue'
import 产品中心 from '@/views/product.vue'
import 案例详情 from '@/views/caseDetail.vue'
import 新闻资讯 from '@/views/news.vue'
import 新闻详情 from '@/views/newsDetail.vue'
import 联系我们 from '@/views/contact.vue'
import 关于广源 from '@/views/about.vue'

Vue.use(Router)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
	  {
	  	path: '/',
	  	name: 'main',
	  	component: 首页,
	  
	  },
    {
      path: '/',
      name: 'home',
      component: home,
      children: [
        {
        	path: 'case',
        	name: 'case',
        	component: 案例展示,
        
        },
		{
			path: 'product',
			name: 'product',
			component: 产品中心,
		
		},
		{
			path: 'productDetails',
			name: 'productDetails',
			component: 产品详情,
		
		},
		{
			path: 'caseDetail',
			name: 'caseDetail',
			component: 案例详情,
		
		},
		{
			path: 'news',
			name: 'news',
			component: 新闻资讯,
		
		},
		{
			path: 'newsDetail',
			name: 'newsDetail',
			component: 新闻详情,
		
		},
		{
			path: 'contact',
			name: 'contact',
			component: 联系我们,
		
		},
		{
			path: 'about',
			name: 'about',
			component: 关于广源,
		
		},
		

        ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js